import { calculatePriceToDisplay } from "../../../pages/admin/admin.dashboard";
import {
  formatFirestoreTimestamp,
  statusColor,
  ticketTypeHolder,
} from "../../../utils";
import type { Ticket } from "../../../utils/types";

export function GuestDetails({ item }: { item: Ticket | null }) {
  return (
    <>
      <button
        type='button'
        className='btn btn-primary view-modal-btn'
        data-bs-toggle='modal'
        data-bs-target='#guest-details-modal'
        id='guest-details-modal-btn'
      >
        View Details
      </button>
      {/* <!-- Modal --> */}
      <div
        className='modal fade details-modal'
        id='guest-details-modal'
        tabIndex={-1}
        aria-labelledby='guest-details-modal-label'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title fs-5' id='guest-details-modal-label'>
                Guest details
              </h1>
              <button
                type='button'
                className='bttn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='bi bi-x-circle'></i>
              </button>
            </div>
            <div className='modal-body'>
              <div className='item'>
                <h6>First name</h6>
                <p>{item?.guest?.firstName}</p>
              </div>
              <div className='item'>
                <h6>Last name</h6>
                <p>{item?.guest?.lastName}</p>
              </div>
              <div className='item'>
                <h6>Email</h6>
                <p>{item?.guest?.email}</p>
              </div>
              <div className='item'>
                <h6>Ticket type</h6>
                <p>
                  <span>
                    {
                      ticketTypeHolder(
                        item?.ticketTitle ?? item?.ticketType ?? ""
                      ).status
                    }
                  </span>
                </p>
              </div>
              <div className='item'>
                <h6>Amount paid</h6>
                <p>{item ? calculatePriceToDisplay(item) : null}</p>
              </div>
              <div className='item'>
                <h6>Bought ticket on</h6>
                <p>
                  {item?.createdAt
                    ? formatFirestoreTimestamp(item?.createdAt)
                    : "-"}
                </p>
              </div>
              <div className='item'>
                <h6>Status</h6>
                <p>
                  {item?.status ? (
                    <span className={`status ${statusColor(item?.status)}`}>
                      {item?.status}
                    </span>
                  ) : (
                    "-"
                  )}
                </p>
              </div>
              <div className='item'>
                <h6>Checked in on</h6>
                <div className='checked-in-on'>
                  {(item?.checkedInAt ?? []).length > 0 ? (
                    item?.checkedInAt?.map((timestamp) => (
                      <p key={timestamp.toDate().getTime()}>
                        {formatFirestoreTimestamp(timestamp)}
                      </p>
                    ))
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
              {Object.keys(item?.otherInfo ?? {})?.map(
                (el: string, index: number) => {
                  return (
                    <div className='item' key={index}>
                      <h6>{el}</h6>
                      <p>{item?.otherInfo?.[el] ?? "-"}</p>
                    </div>
                  );
                }
              )}
              {Object.keys(item?.nonRequiredInfo ?? {})?.map(
                (el: string, index: number) => {
                  return (
                    <div className='item' key={index}>
                      <h6>{el}</h6>
                      <p>{item?.nonRequiredInfo?.[el] ?? "-"}</p>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
